(() => {
  // Bundle the same sections as the theme so the drawer and cart count stay in sync.
  window.PensadoresBookCart ||= {
    requiresReview: false,
    reviewError(message, cause, added = false) {
      this.requiresReview = true;
      const error = new Error(message, { cause });
      error.added = added;
      error.uncertain = !added;
      return error;
    },
    async add(items, trigger) {
      if (this.requiresReview) throw this.reviewError('Confira seu carrinho antes de adicionar outros produtos.');
      const root = window.Shopify?.routes?.root || '/';
      if (window.PensadoresCart) {
        try {
          const result = await window.PensadoresCart.mutate(`${root}cart/add.js`, { items }, { add: true });
          const drawer = document.querySelector('m-cart-drawer');
          if (drawer) drawer.open(trigger); else window.location.assign(`${root}cart`);
          return result;
        } catch (error) {
          if (error.added || error.uncertain) this.requiresReview = true;
          throw error;
        }
      }
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
      const bundled = [...new Set(['cart-drawer', 'cart-count', ...sections])].slice(0, 5);
      let response;
      try {
        response = await fetch(`${root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: bundled, sections_url: window.location.pathname })
        });
      } catch (cause) {
        throw this.reviewError('Não foi possível confirmar a inclusão. Confira seu carrinho antes de tentar novamente.', cause);
      }
      let result;
      try { result = await response.json(); }
      catch (cause) { throw this.reviewError('Não foi possível confirmar a inclusão. Confira os itens do carrinho antes de continuar.', cause); }
      if (!result || typeof result !== 'object') throw this.reviewError('Não foi possível confirmar a inclusão. Confira os itens do carrinho antes de continuar.');
      if (!response.ok || result.status) {
        const message = result.description || 'Não foi possível adicionar essa quantidade. Verifique a disponibilidade.';
        if (response.status === 404) throw new Error(message);
        throw this.reviewError(`${message} Confira os itens do carrinho antes de continuar.`);
      }
      const addedItems = Array.isArray(result.items) ? result.items : [result];
      if (!addedItems.length || addedItems.some(item => !Number.isSafeInteger(Number(item?.variant_id || item?.id)) || Number(item.variant_id || item.id) <= 0 || !Number.isInteger(Number(item.quantity)) || Number(item.quantity) <= 0)) {
        throw this.reviewError('Não foi possível confirmar a inclusão. Confira os itens do carrinho antes de continuar.');
      }
      try {
        const drawer = document.querySelector('m-cart-drawer');
        if (!drawer || !window.MinimogEvents || !window.MinimogTheme) {
          window.location.assign(`${root}cart`);
          return result;
        }
        if (bundled.some(key => !result.sections?.[key])) {
          const refresh = await fetch(`${root}?sections=${bundled.join(',')}`);
          if (!refresh.ok) throw new Error('Cart render failed');
          result.sections = await refresh.json();
        }
        if (!result.sections['cart-drawer']) throw new Error('Cart render empty');
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: result, productVariantId: items[0].id });
        drawer.open(trigger);
      } catch (cause) {
        throw this.reviewError('Os produtos foram adicionados. Abra o carrinho para conferir sua compra.', cause, true);
      }
      return result;
    }
  };
  if (customElements.get('pensadores-book-product')) return;
  class PensadoresBookProduct extends HTMLElement {
    connectedCallback() {
      this.docEvents?.abort();
      this.docEvents = new AbortController();
      document.addEventListener('click', event => {
        const preview = event.target.closest('[data-book-preview]');
        if (preview) this.openPreview(preview.dataset.bookPreview, preview);
        const secondary = event.target.closest('[data-book-add-secondary]');
        if (secondary && !secondary.disabled && !this.busy) {
          this.secondaryTrigger = secondary;
          this.form.requestSubmit(this.form.querySelector('button[type="submit"]'));
        }
      }, { signal: this.docEvents.signal });
      const scheduleSticky = () => {
        cancelAnimationFrame(this.stickyFrame);
        this.stickyFrame = requestAnimationFrame(() => this.syncSticky());
      };
      window.addEventListener('resize', scheduleSticky, { signal: this.docEvents.signal });
      window.addEventListener('scroll', scheduleSticky, { passive: true, signal: this.docEvents.signal });
      if (this.initialized) {
        this.observer?.observe(this.form);
        if (this.combineButton) this.observer?.observe(this.combineButton);
        return;
      }
      this.initialized = true;
      this.form = this.querySelector('.pb-form');
      this.quantity = this.form.querySelector('[name="quantity"]');
      this.variantInput = this.form.querySelector('[name="id"]');
      this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
      this.formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: this.dataset.currency || 'BRL' });
      this.status = this.querySelector('[data-product-status]');
      this.dialog = this.querySelector('dialog');
      this.interiorImages = JSON.parse(this.querySelector('[data-interior-images]').textContent);
      this.galleryImages = [...this.querySelectorAll('[data-zoom]')].map(button => button.dataset.zoom);
      this.previewTitle = this.querySelector('[data-preview-title]').textContent;
      this.addEventListener('click', event => this.onClick(event));
      this.variantInput.addEventListener('change', () => this.updateVariant(true));
      this.quantity.addEventListener('input', () => this.updateQuantity());
      this.form.addEventListener('submit', event => this.submit(event));
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => { if (this.previewTrigger?.isConnected) this.previewTrigger.focus({ preventScroll: true }); });
      this.updateVariant(false);
      this.combineButton = document.querySelector('[data-book-set-add]');
      this.observer = new IntersectionObserver(() => this.syncSticky());
      this.observer.observe(this.form);
      if (this.combineButton) this.observer.observe(this.combineButton);
      this.syncSticky();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.docEvents?.abort(); cancelAnimationFrame(this.stickyFrame); }
    syncSticky() {
      if (!this.form) return;
      const primaryPassed = this.form.getBoundingClientRect().bottom <= 0;
      const actions = [this.form, this.combineButton, document.querySelector('[data-book-add-secondary]')].filter(Boolean);
      const actionVisible = actions.some(element => {
        const rect = element.getBoundingClientRect();
        return rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
      });
      this.querySelector('[data-sticky]').hidden = !primaryPassed || actionVisible;
    }
    openPreview(mode, trigger, selectedSrc) {
      this.previewImages = mode === 'interior' ? this.interiorImages : this.galleryImages;
      if (!this.previewImages.length) return;
      this.previewTrigger = trigger;
      const visibleSrc = this.querySelector('[data-media-panel]:not([hidden]) [data-zoom]')?.dataset.zoom;
      this.previewIndex = mode === 'interior' ? 0 : Math.max(0, this.previewImages.indexOf(selectedSrc || visibleSrc));
      this.querySelector('[data-preview-title]').textContent = mode === 'interior' ? `Por dentro de ${this.previewTitle}` : this.previewTitle;
      this.renderPreview();
      this.dialog.showModal();
    }
    renderPreview() {
      const image = this.querySelector('[data-zoom-image]');
      image.src = this.previewImages[this.previewIndex];
      image.alt = `${this.previewTitle} — imagem ${this.previewIndex + 1}`;
      this.querySelector('[data-preview-count]').textContent = `${this.previewIndex + 1} de ${this.previewImages.length}`;
      this.querySelector('[data-preview-step="-1"]').disabled = this.previewIndex === 0;
      this.querySelector('[data-preview-step="1"]').disabled = this.previewIndex === this.previewImages.length - 1;
    }
    showMedia(id) {
      const target = this.querySelector(`[data-media-panel="${id}"]`);
      if (!target) return;
      this.querySelectorAll('[data-media-panel]').forEach(panel => {
        panel.hidden = panel !== target;
        if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      this.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id))));
    }
    onClick(event) {
      const thumb = event.target.closest('[data-media-target]');
      if (thumb) this.showMedia(thumb.dataset.mediaTarget);
      const zoom = event.target.closest('[data-zoom]');
      if (zoom) this.openPreview('gallery', zoom, zoom.dataset.zoom);
      const previewStep = event.target.closest('[data-preview-step]');
      if (previewStep) {
        this.previewIndex = Math.max(0, Math.min(this.previewImages.length - 1, this.previewIndex + Number(previewStep.dataset.previewStep)));
        this.renderPreview();
        if (previewStep.disabled) this.querySelector('[data-close-zoom]').focus();
      }
      if (event.target.closest('[data-close-zoom]')) this.dialog.close();
      const change = event.target.closest('[data-quantity-change]');
      if (change) {
        if (Number(change.dataset.quantityChange) > 0) this.quantity.stepUp(); else this.quantity.stepDown();
        this.updateQuantity();
      }
    }
    updateVariant(fromSelection) {
      this.variant = this.variants.find(variant => String(variant.id) === this.variantInput.value);
      if (!this.variant) return;
      const variant = this.variant;
      this.querySelectorAll('[data-product-price]').forEach(el => { el.textContent = this.formatter.format(variant.price / 100); });
      const compare = this.querySelector('[data-compare-price]');
      compare.hidden = variant.compare_at_price <= variant.price;
      compare.textContent = this.formatter.format(variant.compare_at_price / 100);
      const installment = this.querySelector('[data-installment]');
      if (installment) installment.textContent = this.formatter.format(Math.round(variant.price / Number(this.dataset.installments)) / 100);
      this.querySelector('[data-availability]').hidden = variant.available;
      const stock = this.querySelector('[data-book-stock]');
      stock.hidden = !(variant.managed && variant.policy === 'deny' && variant.available && variant.inventory > 0 && variant.inventory <= Number(this.dataset.lowStock));
      stock.querySelector('strong').textContent = `Restam ${variant.inventory} ${variant.inventory === 1 ? 'unidade' : 'unidades'}`;
      this.quantity.min = variant.min;
      this.quantity.step = variant.step;
      if (variant.max) this.quantity.max = variant.max; else this.quantity.removeAttribute('max');
      if (fromSelection) {
        this.quantity.value = variant.min;
        this.showMedia(variant.media_id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      this.updateQuantity();
      this.setBusy(Boolean(this.busy));
    }
    updateQuantity() {
      const quantity = Number(this.quantity.value);
      const total = this.variant.price * (Number.isFinite(quantity) && quantity > 0 ? quantity : 1);
      const quantityTotal = this.querySelector('[data-quantity-total]');
      quantityTotal.hidden = quantity <= 1 || !Number.isFinite(quantity);
      quantityTotal.textContent = `${quantity} exemplares · ${this.formatter.format(total / 100)}`;
      document.querySelectorAll('[data-book-editorial-price]').forEach(el => { el.textContent = this.formatter.format(total / 100); });
      document.querySelectorAll('[data-product-quantity-label]').forEach(el => { el.textContent = `${quantity} ${quantity === 1 ? 'exemplar' : 'exemplares'}`; });
      const cashback = this.querySelector('[data-book-cashback]');
      if (cashback) cashback.textContent = this.formatter.format(Math.floor(total * Number(this.dataset.cashback) / 100) / 100);
      this.querySelector('[data-quantity-change="-1"]').disabled = quantity <= Number(this.quantity.min);
      this.querySelector('[data-quantity-change="1"]').disabled = Boolean(this.quantity.max) && quantity >= Number(this.quantity.max);
      document.dispatchEvent(new CustomEvent('pensadores:variant-change', { detail: { variant: this.variant, quantity } }));
    }
    setBusy(busy) {
      this.busy = busy;
      const locked = busy || this.cartReviewRequired;
      this.variantInput.disabled = locked;
      this.quantity.disabled = locked;
      this.querySelectorAll('[data-quantity-change]').forEach(button => { button.disabled = locked; });
      if (!locked) this.updateQuantity();
      document.querySelectorAll('.pb-product .pb-add, [data-book-add-secondary]').forEach(button => {
        button.disabled = locked || !this.variant?.available;
        button.setAttribute('aria-busy', String(busy));
        const label = button.querySelector('[data-add-label]');
        if (label) label.textContent = busy ? 'Adicionando…' : this.cartReviewRequired ? 'Confira o carrinho' : this.variant?.available ? 'Adicionar ao carrinho' : 'Indisponível';
      });
    }
    async submit(event) {
      event.preventDefault();
      const trigger = this.secondaryTrigger || event.submitter;
      this.secondaryTrigger = null;
      if (this.busy || this.cartReviewRequired || !this.variant?.available || !this.form.reportValidity()) return;
      this.status.textContent = '';
      const secondaryStatus = document.querySelector('[data-book-secondary-status]');
      if (secondaryStatus) secondaryStatus.textContent = '';
      this.status.dataset.error = 'false';
      this.setBusy(true);
      try {
        await window.PensadoresBookCart.add([{ id: this.variant.id, quantity: Number(this.quantity.value) }], trigger);
        this.status.textContent = 'Adicionado ao carrinho.';
      } catch (error) {
        this.cartReviewRequired = Boolean(error.added || error.uncertain);
        this.status.dataset.error = String(!error.added);
        this.status.textContent = error.message;
        const link = document.createElement('a');
        link.href = `${window.Shopify?.routes?.root || '/'}cart`;
        link.className = 'pb-text-link';
        link.textContent = 'Ver carrinho';
        this.status.append(' ', link);
      } finally {
        if (secondaryStatus && trigger?.matches('[data-book-add-secondary]')) {
          secondaryStatus.replaceChildren(...[...this.status.childNodes].map(node => node.cloneNode(true)));
          secondaryStatus.dataset.error = this.status.dataset.error;
        }
        this.setBusy(false);
      }
    }
  }
  customElements.define('pensadores-book-product', PensadoresBookProduct);
})();
